<template>
  <div>
    <el-dialog
        title="更新规则"
        :visible.sync="updateDialog"
        width="930px" >
      <div style="margin-left: 100px" v-loading="updateLoading">
        <el-form label-position="top" :model="updateItem" :rules="rules" ref="formRef" label-width="110px">
          <el-row>
            <el-col :span="8">
              <el-form-item label-width="120px" label="院校名称" prop="name">
                <el-input v-model="updateItem.name" style="width: 200px" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-form-item label-width="120px" label="当前状态" prop="score">
                <el-select v-model="updateItem.state" placeholder="请选择" style="width: 200px">
                  <el-option label="洽谈中" :value="1"/>
                  <el-option label="合作中" :value="2"/>
                  <el-option label="已到期" :value="3"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label-width="120px" label="有效日期" prop="startAndEndDate">
                <el-date-picker style="width: 87%"
                                v-model="updateItem.startAndEndDate"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="21">
              <el-form-item label-width="120px" label="备注说明">
                <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="请输入"
                    v-model="updateItem.explain">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialog = false">取 消</el-button>
        <el-button type="danger" :disabled="updateLoading" @click="update">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {updateSchool} from '/src/api/contacts/hr/cooperationSchool'
export default {
  name: "UpdateSchool",
  data() {
    return {
      updateDialog: false,
      updateLoading: false,
      updateItem: {
        name: "",
        startTime: null,
        endTime: null,
        state: null,
        explain: "",
      },
      rules: {
        name: [{ required: true, message: "请输入院校名称！", trigger: "blur" }],
      }
    };
  },
  methods:{
    openDialog(item) {
      this.updateItem = JSON.parse(JSON.stringify(item));
      this.updateItem.startAndEndDate = [
        this.updateItem.startTime,
        this.updateItem.endTime
      ];
      console.log(this.updateItem)
      this.updateDialog = true;
    },
    update(){
      console.log(this.updateItem)
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.updateLoading = true;
          this.updateItem.startTime = this.updateItem.startAndEndDate[0];
          this.updateItem.endTime = this.updateItem.startAndEndDate[1];
          updateSchool(this.updateItem).then(val=>{
            this.updateLoading = false;
            if (val.status == 200){
              this.$emit('refresh');
              this.updateDialog = false;
              this.$notify.success({title: '提示', message: '更新成功！', offset: 40});
              Object.keys(this.updateItem).forEach((key) => (this.updateItem[key] = null));
            }else {
              this.$notify.error({title: '更新失败！', message: val.data, offset: 40});
            }
          })
        }
      })
    },

  },
  created() {
  }
}

</script>

<style scoped>

</style>